function setDatePickerLimits() {
    const datePickers = document.getElementsByClassName("datepicker");
    const minDaysInAdvance = 3;
    const maxDaysInAdvance = 28;

    setMinMaxDate(datePickers, minDaysInAdvance, maxDaysInAdvance);
}

function getDate(days) {
    let date;

    if (days !== undefined) {
        date = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    } else {
        date = new Date();
    }

    const offset = date.getTimezoneOffset();

    date = new Date(date.getTime() - (offset * 60 * 1000));

    return date.toISOString().split("T")[0];
}
function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday = 0, Saturday = 6
}

function getValidDate(date) {
    while (isWeekend(date)) {
        date.setDate(date.getDate() + 1);
    }
    const hour = date.getHours();
    if (hour < 8 || hour > 17) {
        if (hour < 8) {
            date.setHours(8);
        } else {
            date.setHours(17);
        }
    }
    return date;
}

function setMinMaxDate(datePickers, minDaysInAdvance, maxDaysInAdvance) {
    let maxDate = new Date(Date.now() + maxDaysInAdvance * 24 * 60 * 60 * 1000);
    let minDate = new Date(Date.now() + minDaysInAdvance * 24 * 60 * 60 * 1000);
    maxDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    for (let i = 0; i < datePickers.length; i++) {
        datePickers[i].min = getValidDate(minDate).toISOString().slice(0, 16);
        datePickers[i].max = getValidDate(maxDate).toISOString().slice(0, 16);
    }
}


function setDateListenr() {
    setDatePickerLimits();
    const datePickers = document.getElementsByClassName("datepicker");
    for (let i = 0; i < datePickers.length; i++) {
        datePickers[i].addEventListener("input", function (e) {
            let date = getValidDate(new Date(e.target.value));
            date.setHours(date.getHours() + 2);
            datePickers[i].value =  date.toISOString().slice(0, 16)
        });
    }
}


function toLocalISOString(date) {
  const offset = date.getTimezoneOffset();
  const offsetAbs = Math.abs(offset);
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return `${localDate.toISOString().slice(0, -1)}${offset > 0 ? '-' : '+'}${String(Math.floor(offsetAbs / 60)).padStart(2, '0')}:${String(offsetAbs % 60).padStart(2, '0')}`;
}
function disableWeekends() {
    const datePickers = document.getElementsByClassName("datepicker");
    let date = new Date(Date.now() + days * 24 * 60 * 60 * 1000);

    for (let i = 0; i < datePickers.length; i++) {
        datePickers[i].addEventListener("input", function () {
            if (isWeekend(new Date(this.value))) {
                this.value = "";
            }
        });
    }
}
module.exports = { getDate, setDateListenr };